<template>
  <div class="table">
    <div class="table-header">
      <div class="table-row">
        <div class="cell cell-big"> </div>
        <LoadAmountList v-if="hasAmountDropdown" :totalItems="totalItems" @selectedAmount="selectedAmount" />
      </div>
    </div>
    <div class="table-content">
      <div class="table-grid">
        <router-link             
          class="grid-block"
          v-for="(device, index) in DHRDevices"
          :key="index"
          :to="'/production/dhr/master/version/'+ device.deviceRef + '/' + device.deviceID"
        >
          {{ device.deviceRef }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import MoreTableActions from "@/components/base/MoreTableActions";
import LoadAmountList from "@/components/base/LoadAmountList";

export default {
  components: {
    BaseIcon,
    MoreTableActions,
    LoadAmountList
  },
   
  props: {
    DHRDevices: {
      type: Array,
      required: true
    },
    hasAmountDropdown: {
      type: Boolean,
      default: true
    },
    totalItems: Number
  },
  mounted() {

  },
  data() {
    return {
      selectedDHR: null,
      sortingOn: "ref",
      isAscending: true,
      isOptionOpen: false,
      openOptions: ""
    };
  },
  methods: {
    selectedAmount(val) {
      this.$emit("selectedAmount", val);
    },
    selectRow(dhr) {
      if (this.selectedDHR != dhr) {
        this.isOptionOpen = false;
      }
      this.selectedDHR = dhr;
      this.$emit("selectedRow", dhr);
    },
    openMenu(index) {
      if (this.openOptions != index) {
        this.isOptionOpen = true;
      } else {
        this.isOptionOpen = !this.isOptionOpen;
      }
      this.openOptions = index;
    },
    setSorting(val) {
      if (this.sortingOn != val) {
        this.isAscending = true;
      } else {
        this.isAscending = !this.isAscending;
      }
      this.sortingOn = val;

      this.$emit("sorting", { on: this.sortingOn, asc: this.isAscending });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/base.scss";
@import "../style/components/tables.scss";
@import "@/style/components/active.scss";

.table-header {
  .table-row {
    .cell.sort {
      cursor: pointer;
    }
  }
}

.status-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;

  &.approved {
    background-color: #E9F9EA;
    color: #2AA328;
  }
  &.completed {
    background-color: #D6E9FC;
    color: #3390F2;
  }
  &.in-progress {
    background-color: #FDECD9;
    color: #D08F40;
  }
}

.table-grid {
  max-height: 100%;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-column-gap: 8px;
  grid-row-gap: 8px;

  .grid-block {
    background-color: $white;
    border-radius: 5px;
    font-size: 12px;
    color: black;
    font-weight: 600;
    min-width: 200px;
    width: 16%;
    height: 66px;
    margin: 8px 0;
    margin-right: 12px;

    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    &:hover {
      cursor: pointer;
      text-decoration: none;
      color: black;
      background-color: $white;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.16);
    }
  }
}
</style>
